import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
  },
  list: [],
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.CLINIC_GET_REQUESTED:
      return {
        ...state,
        status: {
          loading: 0,
        },
      };
    case ACTION_TYPES.CLINIC_GET_SUCCEED:
      return {
        ...state,
        status: {
          loading: 1,
        },
        list: [...payload.data],
        // meta: payload.meta,
      };
    case ACTION_TYPES.CLINIC_GET_FAILED:
      return {
        ...state,
        status: {
          loading: 2,
        },
        error,
      };
    default:
      return state;
  }
}
